import type { QBankStructureLevel } from '@exam-management/qbs-provider';

export function findNextEnabledLevel(levels: QBankStructureLevel[], currentLevelId: string) {
  const { level } = levels.find((level) => level.id === currentLevelId) ?? {};
  if (level === undefined) {
    return null;
  }

  const nextLevel = levels.find((l) => l.level === level + 1);
  if (!nextLevel) {
    return null;
  }
  if (!nextLevel.enabled) {
    return findNextEnabledLevel(levels, nextLevel.id);
  }

  return nextLevel;
}

export function findPreviousEnabledLevel(levels: QBankStructureLevel[], currentLevelId: string) {
  const { level } = levels.find((level) => level.id === currentLevelId) ?? {};
  if (level === undefined) {
    return null;
  }

  const previousLevel = levels.find((l) => l.level === level - 1);
  if (!previousLevel) {
    return null;
  }
  if (!previousLevel.enabled) {
    return findPreviousEnabledLevel(levels, previousLevel.id);
  }

  return previousLevel;
}
